function setupAccordion(accParents) {
	const openTab = (e, tabName) => {
		const tabContent =
			document.getElementsByClassName("carney-tab-content");
		const tabLinks = document.getElementsByClassName("carney-tab-link");

		if (tabContent.length == 0 || tabLinks.length == 0) {
			return;
		}

		Array.from(tabContent).forEach((tab) => {
			tab.style.display = "none";
		});

		Array.from(tabLinks).forEach((link) => {
			link.nextElementSibling.className =
				link.nextElementSibling.className.replace(" active", "");
		});

		const tab = document.getElementById(tabName);
		if (tab) {
			tab.style.display = "block";
			e.currentTarget.nextElementSibling.className += " active";
		}
	};

	const tabLinks = document.getElementsByClassName("carney-tab-link");
	Array.from(tabLinks).forEach((link) => {
		link.addEventListener("change", function (e) {
			openTab(e, link.dataset.tab);
		});
	});

	if (tabLinks.length > 0) {
		tabLinks[0].dispatchEvent(new Event("change"));
	}

	accParents.forEach((parent) => {
		let acc = Array.from(
			parent.getElementsByClassName("carney-accordion-span")
		);

		acc.forEach((item, index) => {
			let span = document.createElement("span");
			span.classList.add("carney-accordion-span__number");
			span.textContent = index + 1;
			item.insertBefore(span, item.firstChild);

			item.addEventListener("click", function (e) {
				let clickedItem = e.target;
				let content = clickedItem.nextElementSibling;
				acc.forEach((el) => {
					if (el !== clickedItem) {
						el.classList.remove("active");
						let collapsingContent = el.nextElementSibling;
						collapsingContent.classList.remove("accordionPop");
						collapsingContent.classList.add("accordionCollapse");
						setTimeout(() => {
							collapsingContent.style.display = "none";
						}, 400);
					}
				});

				clickedItem.classList.toggle("active");
				let expandingContent = content;
				expandingContent.style.display = clickedItem.classList.contains(
					"active"
				)
					? "block"
					: "none";
				expandingContent.classList.remove("accordionCollapse");
				expandingContent.classList.add(
					clickedItem.classList.contains("active")
						? "accordionPop"
						: "accordionCollapse"
				);
			});
		});
	});
}

window.addEventListener("DOMContentLoaded", () => {
	const accParents = Array.from(
		document.querySelectorAll(".carneyAccordion")
	);
	setupAccordion(accParents);
});
